<template>
  <div class="section-sub-schedule" data-aos="fade-up" data-aos-once="true">

    <!-- header -->
    <page-subtab :title-infos="dates" :selected-index="dateIndex" @title-changed="onDateChanged"></page-subtab>

    <!-- <div-container>
      currentDate: {{ currentDate }},
      currentDateScheduleLoaded: {{ currentDateScheduleLoaded }},
      items[currentDate]: {{ items[currentDate] }},
      items: {{ items }}
    </div-container> -->

    <div-container v-if="currentDate && currentDateScheduleLoaded && items[currentDate]">
      <div class="columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile">
        <div class="column is-11 has-text-left content">
          <div v-for="item in items[currentDate]" class="columns is-gapless is-centered is-multiline content-row">
            <div class="column is-4 has-text-left content-date">
              <h2><p>
                {{ item.full_date }}
              </p></h2>
            </div>
            <div class="column is-8 has-text-left content-description">
              <h2>
                <span v-html="item.description">
                </span>
              </h2>
            </div>
          </div>
          <!-- <div class="control notification is-danger" v-if="error">
            <button class="delete" @click="error = undefined"></button>
            <p v-html="error">
            </p>
          </div> -->
        </div>
      </div>
    </div-container>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import PageSubtab from '@/components/PageSubtab'
import ShowDown from 'showdown'
import 'showdown-target-blank'
import moment from 'moment'

export default {
  name: 'section-sub-schedule',
  props: ['title'],
  components: {
    DivContainer,
    PageSubtab
  },
  data () {
    return {
      currentDate: undefined,
      currentDateScheduleLoaded: false,
      dates: [],
      dateIndex: 0,
      items: [],
      itemsLoaded: false,
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    onDateChanged: function (date) {
      console.log(date + ' changed@')
      this.currentDateScheduleLoaded = false
      if (this.items[date]) {
        this.currentDate = date
        this.currentDateScheduleLoaded = true
        return
      }
      this.getSchedules(date)
    },

    getDates: function () {
      this.loading = true
      this.error = undefined
      Site.scheduleDates()
      .then((data) => {
        this.loading = false
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }
        this.onDateComplete(data)
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    getSchedules: function (date) {
      this.loading = true
      this.error = undefined
      Site.scheduleWithDate(date)
      .then((data) => {
        this.loading = false
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }
        this.onSchedulesComplete(date, data)
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    convertDate: function (value) {
      if (!value) {
        return undefined
      }
      value = value.replace(/\s/, 'T')
      value = moment(new Date(value)).format('MMMM D, YYYY')
      return value
    },

    convertDateTitle: function (value) {
      if (!value) {
        return undefined
      }
      value = value.replace(/\s/, 'T')
      var day = moment(value).format('E')
      switch (day) {
        case '0':
        case '7':
          day = 'Sunday'
          break
        case '1':
          day = 'Monday'
          break
        case '2':
          day = 'Tuesday'
          break
        case '3':
          day = 'Wednesday'
          break
        case '4':
          day = 'Thursday'
          break
        case '5':
          day = 'Friday'
          break
        case '6':
          day = 'Saturday'
          break
        default:
          day = 'Invalid'
          break
      }
      var date = moment(value).format('MMMM D')
      return day + ', ' + date
    },

    convertTime: function (value) {
      if (!value) {
        return undefined
      }
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('h:mm A')
      // note: issue with safari, but the following is wrong too..
      // value = value.replace(/\s/, 'T')
      // return moment(new Date(value)).format('h:mm A')
    },

    onDateComplete: function (dates) {
      // console.log('loaded dates')
      // console.log(dates)
      if (dates && dates.length > 0) {
        this.currentDate = dates[0]
      }
      for (var j = 0; j < dates.length; j++) {
        var date = dates[j]
        this.dates.push({
          id: date,
          title: this.convertDateTitle(date) + ''
        })
        this.getSchedules(date)
      }
      // // ---- test start
      // this.currentDateScheduleLoaded = false
      // var current = '2019-05-10'
      // this.dates = [{
      //   id: '2019-05-10',
      //   title: this.convertDateTitle('2019-05-10')
      // }, {
      //   id: '2019-05-11',
      //   title: this.convertDateTitle('2019-05-11')
      // }]
      // for (var i = 0; i < 2; i++) {
      //   var id = this.dates[i].id
      //   this.items[id] = []
      //   this.getSchedules(id)
      // }
      // this.$nextTick(function () {
      //   this.currentDate = current
      //   this.currentDateScheduleLoaded = true
      // }.bind(this))
      // // ---- test end
      // if (dates && dates.length > 0) {
      //   this.currentDate = dates[0]
      //   for (var i = 0; i < dates.length; i++) {
      //     var date = dates[i]
      //     this.getSchedules(date)
      //   }
      // }
    },

    onSchedulesComplete: function (date, schedules) {
      // console.log('loaded schedules')
      // console.log(date)
      // console.log(schedules)
      for (var i = 0; i < schedules.length; i++) {
        var schedule = schedules[i]
        if (schedule.description) {
          var converter = new ShowDown.Converter({ extension: ['targetblank'] })
          var html = converter.makeHtml(schedule.description)
          schedule.description = html
        }

        // var startDate = this.convertDate(schedule.date_start)
        var startTime = this.convertTime(schedule.date_start)
        // var endDate
        var endTime
        var fullDateTime = 'invalid'
        if (schedule.date_start === schedule.date_end) {
          schedule.date_end = undefined
        }
        if (schedule.date_end) {
          // only start time and end time
          // endDate = this.convertDate(schedule.date_end)
          endTime = this.convertTime(schedule.date_end)
          // only start time and end time
          fullDateTime = startTime + ' - ' + endTime
          // if (startDate === endDate) {
          //   // only start time and end time
          //   fullDateTime = startTime + ' - ' + endTime
          // } else {
          //   // different start date & end date
          //   fullDateTime = startTime + ' - ' + endDate + ' ' + endTime
          // }
        } else {
          // only start date & time
          fullDateTime = startTime
        }
        schedules[i].full_date = fullDateTime
      }

      this.items[date] = schedules

      if (date === this.currentDate) {
        this.currentDateScheduleLoaded = true
      }
    },

    onScheduleUpdated: function (date) {
      // switch date
      // console.log(date + ' updated!!11')
    },

    refresh: function () {
      this.getDates()
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section schedule

.section-sub-schedule {
  padding-top: 3rem;
  padding-bottom: 3rem;

  .title:not(:last-child),
  .subtitle:not(:last-child) {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 0.1em;
  }

  .title:last-child,
  .subtitle:last-child {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 1em;
  }

  p {
    font-size: 1em;
    text-align: left;
    padding-left: 0.75em;
    padding-right: 0.75em;

    &:not(:first-child) {
      margin-top: 1em;
      @media screen and (min-width: $tablet) {
        margin-top: 1em;
      }
    }
  }

  .columns.is-gapless:not(:last-child) {
    margin-bottom: 0;
  }

  .columns.is-gapless > .column {

    &.content-images {
      background-color: white;
      padding: 30px 10px;

      @media screen and (min-width: $tablet) {
        padding: 20px 10px;
      }

      img {
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }

    &.content {
      background-color: white;
      padding: 30px 15px;

      @media screen and (min-width: $tablet) {
        padding: 30px 50px;
      }

      .content-date, .content-description {

        img {
          display: block;
          margin-left: auto;
          margin-right: auto;
        }

        p, li, h1, h2, h3, h4, h5, h6, strong {
          color: $color-darkbrown;
          letter-spacing: 0;
        }

        p, li {
          line-height: 1.8em;
        }

        h1, h2, h3, h4, h5, h6 {
          // font-family: $font-family-title;
          // font-weight: bold;
          // text-transform: uppercase;

          // &:not(:first-child) {
          //   margin-top: 2rem;
          // }
          // margin-bottom: 1rem;
          //
          // @media screen and (min-width: $tablet) {
          //   &:not(:first-child) {
          //     margin-top: 3rem;
          //   }
          //   margin-bottom: 2rem;
          // }

          &:not(:first-child) {
            margin-top: 0;
          }

          a {
            margin-left: 30px;
          }
        }

        h1, h2 {
          &:not(:first-child) {
            margin-top: 3rem;
          }
        }
      }

      .content-row {
        &:not(:first-child) {
          margin-top: 3em;
          @media screen and (min-width: $tablet) {
            margin-top: 0em;
          }
        }
      }

      .content-date {
        h1, h2, h3, h4, h5, h6 {
          // font-family: $font-family-title;
          font-size: 1.1em;
        }
      }

      .content-description {
        h1, h2, h3, h4, h5, h6 {
          font-size: 1.1em;
        }
      }
    }
  }

  ul {
    list-style: disc;
    margin-left: 2em;
  }
}

</style>



// WEBPACK FOOTER //
// ScheduleSubSection.vue?7d98e207